import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
//----- store
import { fetchPageData } from "../store/ActionDetails-actions";

import Box from "@material-ui/core/Box";
import TableGeralData from "../components/TableGeralData/TableGeralData";
import TableNextSessions from "../components/TableNextSessions/TableNextSessions";
import HeaderBreadCrumb from "../components/HeaderBreadCrumb/HeaderBreadCrumb";
import BoxTitle from "../components/BoxTitle/BoxTitle";
import IconTitle from "../components/IconTitle/IconTitle";

import Styles from "./ActionDetails.module.css";

const ActionDetails = () => {
	const dispatch = useDispatch();
	const [actionDetailsDataLoaded, setActionDetailsData] = useState(false);
	const params = useParams();
	const history = useHistory();
	// console.log(params.actionId)

	const ActionDetailsData = useSelector((state) => state.ActionDetailsData);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.actionDetails +
		"/" +
		params.actionId;

	const returnClickHandler = () => {
		history.goBack();
	};

	useEffect(() => {
		dispatch(fetchPageData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		if (ActionDetailsData.pageData.modality.id !== "") {
			console.log("ActionDetailsData", ActionDetailsData);
			setActionDetailsData(true);
		}
	}, [ActionDetailsData]);

	return (
		<div className={Styles["actionDetails"]} style={{ color: "#ededed" }}>
			{actionDetailsDataLoaded && (
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						{/* <div className={"col-xs-12 title"}>
							<HeaderBreadCrumb />
						</div> */}
						<IconTitle
							title={ActionDetailsData.pageData.name}
							onClick={returnClickHandler}
						/>
					</div>
					<div className={"row"}>
						<div className={"col-xs-12"}>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<TableGeralData
											modality={
												ActionDetailsData.pageData
													.modality.name
											}
											status={
												ActionDetailsData.pageData
													.enrollmentStatus.nome
											}
											endDate={
												ActionDetailsData.pageData
													.shortEndDate
											}
											startDate={
												ActionDetailsData.pageData
													.shortStartDate
											}
											duration={
												ActionDetailsData.pageData
													.duration
											}
										/>
									</Box>
								</div>
							</div>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<BoxTitle title="Próximas sessões" />
										<TableNextSessions
											TableNextSessionsData={
												ActionDetailsData
											}
										/>
									</Box>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ActionDetails;
